var _path, _path2, _g, _rect, _rect2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAdv1Dark = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 29.4988L7 32.9988L1.1415 26.1639C1.0859 26.099 1.13199 25.9988 1.21742 25.9988H4.02344C4.27932 20.8023 6.51856 16.1272 10 12.7148",
    stroke: "#FF643D",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2126_58009",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 1,
    width: 30,
    height: 36
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.6574C9 11.1206 9.21578 10.6063 9.59882 10.2302L18.4165 1.57287C18.7905 1.20571 19.2936 1 19.8177 1H37C38.1046 1 39 1.89543 39 3V27C39 32.5228 34.5228 37 29 37H11C9.89543 37 9 36.1046 9 35V11.6574Z",
    fill: "#B3B2C2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2126_58009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 11.6574C9 11.1206 9.21578 10.6063 9.59882 10.2303L18.4165 1.57287C18.7905 1.20571 19.2936 1 19.8177 1H37C38.1046 1 39 1.89543 39 3V31C39 34.3137 36.3137 37 33 37H11C9.89543 37 9 36.1046 9 35V11.6574Z",
    fill: "url(#paint0_linear_2126_58009)"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 8,
    width: 12,
    height: 12,
    fill: "#C0BCD4"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 15,
    y: 18,
    width: 18,
    height: 3,
    rx: 1,
    fill: "#D0CEE3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 15,
    y: 23,
    width: 18,
    height: 3,
    rx: 1,
    fill: "#D0CEE3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 42C24 41.4477 24.4492 41.0037 25.0001 40.9648C32.2653 40.452 38 34.3957 38 27H35.2185C35.1331 27 35.087 26.8998 35.1426 26.8349L41.0011 20L46.8596 26.8349C46.9152 26.8998 46.8691 27 46.7837 27H44C44 37.7104 35.581 46.4545 24.9999 46.9754C24.4482 47.0026 24 46.5523 24 46V42Z",
    stroke: "#FF643D",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2126_58009",
    x1: 13.4444,
    y1: 6.625,
    x2: 43.2546,
    y2: 36.0672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E6F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0BCD4"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAdv1Dark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/adv1Dark.a84f02be9e943368e6796a42b812d26a.svg";